<template>
  <view-edit-panel
    class="losses"
    v-model="losses"
    :disable-save="invalidForm"
    :loading="loading"
    @changing="save"
  >
    <b-container
      fluid
      slot-scope="data"
      class="losses"
    >
      <b-row
        v-if="loading"
        class="losses__loader"
        align-h="center"
        align-v="center"
      >
        <s-loader size="lg" />
      </b-row>
      <b-row v-else class="px-3">
        <losses-form
          :losses="data.item"
          :saving="data.saving"
          :edit-mode="data.editing"
          @form-status-update="formStatusUpdate"
        />
      </b-row>
    </b-container>
  </view-edit-panel>
</template>

<script>
import ViewEditPanel from '@/components/ViewEditPanel';
import lossesService from '@/domain/services/installation/assetInfo/losses';
import LoadingMixin from '@/services/loadingMixin';
import LossesForm from '@/domain/components/installation/assetInformation/transformers/losses/Form';
import TreeviewHeaderSubtitleMixin from '@/components/treeview/treeviewHeaderSubtitleMixin';

export default {
  name: 'Losses',
  components: {
    ViewEditPanel,
    LossesForm,
  },
  mixins: [
    LoadingMixin,
    TreeviewHeaderSubtitleMixin,
  ],
  data: () => ({
    losses: {},
    invalidForm: false,
  }),
  created() {
    this.getLosses();
    this.updateHeaderTitle(this.$t('asset-information.asset-info.losses.title'));
  },
  methods: {
    getLosses() {
      const { assetId } = this.$route.params;
      this.startLoading();
      lossesService.getLosses(assetId).then((response) => {
        this.losses = response;
      }).finally(() => { this.endLoading(); });
    },
    save({ newValue, accept, reject }) {
      const { assetId } = this.$route.params;
      lossesService.updateLosses(newValue, assetId).then((response) => {
        this.losses = response;
        accept();
      }).catch(reject);
    },
    formStatusUpdate(value) {
      this.invalidForm = value;
    },
  },
};

</script>

<style lang="sass" scoped>
  .losses
    &__loader
      height: 500px
</style>
